<template>

    <div class="homeContainer">
        <div class="logoMurprotect">
            <img class="backIcon" style="visibility: hidden" src="/images/icn_back.png" @click="$router.push('home')" />
            <img src="/images/logo_murprotect.png"/>
        </div>
        <div class="routerContainer">
            <a class="route" @click="$router.push('/link')">
                <img v-if="links.length > 0" src="/images/home/btn_url_on.png" />
                <img v-else src="/images/home/btn_url_off.png" />
            </a>
            <a class="route" @click="$router.push('/pdf')">
                <img v-if="pdfs.length > 0" src="/images/home/btn_pdf_on.png" />
                <img v-else src="/images/home/btn_pdf_off.png" />
            </a>
            <a class="route" @click="$router.push('/user')">
                <img v-if="users.length > 0" src="/images/home/icn_user.png" />
                <img v-else src="/images/home/icn_user.png" />
            </a>
        </div>
        <div class="logoutButton">
            <a class="button is-primary" @click="logout()">
                {{ $t('home.logout') }}
            </a>
        </div>
    </div>

</template>

<script>
    import firebase from 'firebase/app';
    import {mapState} from 'vuex';
    import BIcon from "buefy/src/components/icon/Icon";

    export default {
        components: {BIcon},
        name: 'home',
        computed: {

            ...mapState('user', {

                users: 'list'
            }),
            ...mapState('link', {

                links: 'list'
            }),
            ...mapState('pdf', {

                pdfs: 'list'
            }),


        },

        methods: {
            logout: function () {
                firebase.auth().signOut().then(() => {
                    this.$router.replace({name: 'Login'})
                })
            },

        }
    }
</script>


<style lang="scss" scoped>


    .routerContainer {

        img {
            height: 15rem;
        }
    }

    .logoutButton{
        padding-top: 5%;
    }



</style>
